module.exports = __webpack_public_path__ + "static/media/revue-de-l-arbitrage-2018-n-1-9782555551275.78851128.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/revue-de-l-arbitrage-2018-n-1-9782555551275.jpg
// module id = 1398
// module chunks = 1